import { useState, useEffect, useRef } from "react";
import { CloseOutlined, UsergroupAddOutlined, FormOutlined, FileSearchOutlined, FileDoneOutlined, FileAddOutlined } from "@ant-design/icons";
import { Translate } from "../../translate";
import { getStore } from "../../utils/global";
import Step0 from "./Step0";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { Steps } from "antd";

export default function Upload({ params }) {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  const step1Ref = useRef();
  const step2Ref = useRef();
  const step4Ref = useRef();

  const { main, mainfilter, pop, popfilter } = params;
  const [docData, setDocData] = useState({
    docid: 0,
    txn_id: 0,
    file: false,
    parts: [],
    stamps: [],
  });

  const close = () => {
    setDocData({
      docid: 0,
      txn_id: 0,
      file: false,
      parts: [],
      stamps: [],
    });
    window.location.hash = `#/${main}/${mainfilter}/0/0`;
  };

  const back = () => {
    window.location.hash = `#/${main}/${mainfilter}/${pop}/${popfilter * 1 - 1}`;
  };

  const handleNext = async () => {
    if (popfilter === "1") {
      const { success, parts } = await step1Ref.current.next();
      if (success) {
        setDocData({ ...docData, parts });
        window.location.hash = `#/${main}/${mainfilter}/${pop}/2`;
      }
    } else if (popfilter === "2") {
      const res = await step2Ref.current.next();
      if (!res) return;
      const { success } = res;
      if (success) {
        window.location.hash = `#/${main}/${mainfilter}/${pop}/3`;
      }
    } else if (popfilter === "3") {
      window.location.hash = `#/${main}/${mainfilter}/${pop}/4`;
    } else if (popfilter === "4") {
      await step4Ref.current.finish();
    }
  };

  useEffect(() => {
    if (pop === "0" || (pop === "upload" && popfilter === "0")) {
      setDocData({
        docid: 0,
        txn_id: 0,
        file: false,
        parts: [],
        stamps: [],
      });
    }
    if (pop === "upload" && docData.docid === 0) {
      window.location.hash = `#/${main}/${mainfilter}/${pop}/0`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pop, popfilter]);

  return (
    <div className="upload_container" is_show={pop === "upload" ? 1 : 0}>
      {pop === "upload" ? (
        <>
          <div className="upload_header" bg_color="2" active_step={popfilter}>
            <div className="upload_header_close flex_center" onClick={close} color="3">
              <CloseOutlined />
            </div>
            <div className="upload_header_back">
              <div className="btn flex_center" onClick={back} bg_color="3">
                {Translate[ln].NewDoc.Back}
              </div>
            </div>
            <div className="upload_header_ind_container flex_center">
              <Steps
                style={{ margin: "0 16px", maxWidth: "800px" }}
                size="small"
                items={[
                  {
                    status: parseInt(popfilter) > 0 ? "finish" : parseInt(popfilter) === 0 ? "process" : "wait",
                    icon: <FileAddOutlined color={parseInt(popfilter) === 0 && "3"} />,
                    title: Translate[ln].NewDoc.Upload["Upload"],
                  },
                  {
                    status: parseInt(popfilter) > 1 ? "finish" : parseInt(popfilter) === 1 ? "process" : "wait",
                    icon: <UsergroupAddOutlined color={parseInt(popfilter) === 1 && "3"} />,
                    title: Translate[ln].NewDoc.Upload["Participants"],
                  },
                  {
                    status: parseInt(popfilter) > 2 ? "finish" : parseInt(popfilter) === 2 ? "process" : "wait",
                    icon: <FormOutlined color={parseInt(popfilter) === 2 && "3"} />,
                    title: Translate[ln].NewDoc.Upload["Customizations"],
                  },
                  {
                    status: parseInt(popfilter) > 3 ? "finish" : parseInt(popfilter) === 3 ? "process" : "wait",
                    icon: <FileSearchOutlined color={parseInt(popfilter) === 3 && "3"} />,
                    title: Translate[ln].NewDoc.Upload["Preview"],
                  },
                  {
                    status: parseInt(popfilter) === 4 ? "process" : "wait",
                    icon: <FileDoneOutlined color={parseInt(popfilter) === 4 && "3"} />,
                    title: Translate[ln].NewDoc.Upload["Finish"],
                  },
                ]}
                current={parseInt(popfilter)}
              />
            </div>
            <div className="upload_header_next">
              <div className="btn flex_center" bg_color="3" onClick={handleNext}>
                {parseInt(popfilter) === 4 ? Translate[ln].NewDoc.Send : Translate[ln].NewDoc.Next}
              </div>
            </div>
          </div>
          <div className="upload_body">
            {popfilter === "0" && <Step0 setDocData={setDocData} />}
            {popfilter === "1" && <Step1 data={docData} ref={step1Ref} />}
            {popfilter === "2" && <Step2 data={docData} ref={step2Ref} setStamps={(stmp) => setDocData({ ...docData, stamps: stmp })} />}
            {popfilter === "3" && <Step3 data={docData} />}
            {popfilter === "4" && <Step4 data={docData} ref={step4Ref} />}
          </div>
          <div className="upload_footer">
            <div className="upload_footer_powered">
              Powered by&nbsp;<b>Vsign</b>
            </div>
            <div className="upload_footer_menu_container"></div>
            <div className="upload_footer_copy">Copyright © 2021 Vsign All rights reserved</div>
          </div>
        </>
      ) : (
        <div />
      )}
    </div>
  );
}
